<template>
    <xx-select
        v-model="model"
        v-bind="$attrs"
        :multiple="multiple"
        :list="list"
        :use-scroll="true"
        class="supplier-select"
        v-on="$listeners"
        @change="change"
    />
</template>

<script>
export default {
    name: 'SimpleSupplierSelect',
    props: {
        value: {
            type: [String, Number, Array],
            default: '',
            required: true,
        },
        // eslint-disable-next-line vue/require-default-prop
        allValue: {
            type: [String, Number],
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        selectFirst: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            model: this.value || '',
            list: [],
        };
    },
    watch: {
        value: {
            deep: true,
            handler(v) {
                this.model = v;
            },
        },
    },
    created() {
        this.fetchSupplier();
    },
    methods: {
        async fetchSupplier() {
            const res = await this.$hGet('/api/m/vss/supplier/query/supplier-list', {}, { cache: true });
            const list = (res || []).map((item) => ({ value: item.supplierId, label: item.supplierName }));

            if (this.allValue && list) {
                list.unshift({ label: '全部', value: this.allValue });
            }
            this.list = list;
            this.$emit('loaded', this.list);
            if (this.selectFirst && list.length) {
                const value = list[0].value;
                const v = this.multiple ? [value] : value;
                this.$emit('input', v);
            }
        },
        change(v) {
            this.$emit('input', v);
        },
    },
};
</script>

<style lang="scss" scoped>
.supplier-select {
    /deep/ {
        .el-input.is-focus .el-input__inner,
        .el-input__inner:focus {
            border-color: #00ceb0;
        }
    }
}
</style>
